import { createBrowserRouter, Navigate } from 'react-router';

import { AppLayout } from './components/AppLayout';
import { AppPage } from './pages/AppPage';
import { LoginPage } from './pages/LoginPage';
import { OverviewPage } from './pages/OverviewPage';
import { SettingsPage } from './pages/SettingsPage';

/**
 * react-router v7, library mode. `/login` sits OUTSIDE the shell layout on
 * purpose: an unauthenticated visitor must not see an app frame (it would
 * imply they are still in).
 *
 * `/settings` is the canonical URL of «Настройки»; `/admins` is kept as an
 * alias (2026-10-30 — the page outgrew its admin-list origin) so old
 * bookmarks and shared links keep working.
 */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'app/:app', element: <AppPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'admins', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
